// Pure helpers consumed by list-field.tsx: per-element default value
// generation + immutable array mutations (replace / remove / swap).

import type { FieldNode } from '../schema-to-fields'

export function defaultValueFor(node: FieldNode): unknown {
  if (node.defaultValue !== undefined) return node.defaultValue
  switch (node.kind) {
    case 'object':
    case 'union':
      return {}
    case 'array':
      return []
    case 'literal':
      return node.value
    case 'unsupported':
      return null
    default:
      return ''
  }
}

export function replaceAt(items: readonly unknown[], i: number, next: unknown): unknown[] {
  const arr = [...items]
  arr[i] = next
  return arr
}

export function removeAt(items: readonly unknown[], i: number): unknown[] {
  return items.filter((_, j) => j !== i)
}

export function swap(items: readonly unknown[], i: number, j: number): unknown[] {
  const arr = [...items]
  const tmp = arr[i]
  arr[i] = arr[j]
  arr[j] = tmp
  return arr
}
